module.exports = __webpack_public_path__ + "img/pictos.7c00f660.png";